// src/components/ModuloGuard.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useModulos } from '../hooks/useModulos';
import { useAuth } from '../context/AuthContext';
import './ModuloGuard.css';

/**
 * Componente que protege rutas basándose en si el módulo está habilitado
 * @param {string} moduloKey - Clave del módulo a verificar (ej: 'amenidades', 'chat_comunitario')
 * @param {ReactNode} children - Contenido a renderizar si el módulo está habilitado
 */
const ModuloGuard = ({ moduloKey, children }) => {
    const { userData } = useAuth();
    const { modulos, loading } = useModulos(userData?.fraccionamientoId);

    // Mientras carga, mostrar loader
    if (loading) {
        return (
            <div className="modulo-loading">
                <div className="spinner"></div>
                <p>Cargando...</p>
            </div>
        );
    }

    // Si el módulo no está habilitado, redirigir
    if (modulos[moduloKey] !== true) {
        return <Navigate to="/comunidad" replace />;
    }

    // Si el módulo está habilitado, renderizar el contenido
    return <>{children}</>;
};

export default ModuloGuard;

